import DepositACheckPage, { getDefaultPageData } from "components/pages/DepositACheckPage";
import { Account } from "model";
import { useGlobalController, BCMSRecord } from "bcms-react";
import Classes from "model";

export default function CaptureMabiDepositsAmountEntered(props) {
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    
    const data = getDefaultPageData();
    
    data.deposit.account = Account.firstInstanceOf();
    data.deposit.amount = 20;

    return <DepositACheckPage data={ data } />
}